import React, { FC } from 'react'
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Tooltip,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { BarChartBox, EmptyState } from './styles'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip)

export interface AgeGenderItem {
  faixa: string
  masculino: number
  feminino: number
  outros?: number
}

/** Faixa etária com barras divergentes: Feminino à esquerda, Masculino à direita. */
const AgeGenderChart: FC<{ items: AgeGenderItem[] }> = ({ items }) => {
  const hasData = items.some((i) => i.masculino || i.feminino || (i.outros || 0))

  if (!items.length || !hasData) {
    return <EmptyState>Sem data de nascimento suficiente no período.</EmptyState>
  }

  const totalGeral = items.reduce(
    (s, i) => s + Math.abs(i.masculino) + Math.abs(i.feminino) + Math.abs(i.outros || 0),
    0
  )

  const data = {
    labels: items.map((i) => i.faixa),
    datasets: [
      {
        label: 'Feminino',
        data: items.map((i) => -Math.abs(i.feminino)),
        backgroundColor: '#B0020B',
        borderRadius: 4,
        barThickness: 12,
      },
      {
        label: 'Masculino',
        data: items.map((i) => Math.abs(i.masculino)),
        backgroundColor: '#212121',
        borderRadius: 4,
        barThickness: 12,
      },
    ],
  }

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'top' as const,
        align: 'end' as const,
        labels: { boxWidth: 8, usePointStyle: true, padding: 16 },
      },
      tooltip: {
        callbacks: {
          label: (ctx: any) => {
            const val = Math.abs(ctx.parsed.x)
            const pct = totalGeral > 0 ? ((val / totalGeral) * 100).toFixed(1) : '0'
            return ` ${ctx.dataset.label}: ${val} (${pct}% do total)`
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { callback: (v: any) => Math.abs(v) },
        grid: { color: '#F2F4F7' },
      },
      y: {
        stacked: true,
        grid: { display: false },
      },
    },
  }

  return (
    <BarChartBox $height={Math.max(items.length * 38, 220)}>
      <Bar data={data} options={options as any} />
    </BarChartBox>
  )
}

export default AgeGenderChart
